var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":"white","flat":"","padless":""}},[_c('v-card',{attrs:{"flat":"","width":"100%","height":"5rem"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }